module.exports = __webpack_public_path__ + "static/img/my-score.64aee12a.png";